import React, { PureComponent } from 'react';
import { View, StatusBar, BackHandler, Dimensions } from 'react-native';
import { StatusBar as QStatusBar, DeviceInfo } from 'qunar-react-native';
import NaviBar from '../FloatCalendar/Navibar';
import { QSectionCalendar, CALENDAR_TYPE } from '../Calendar';
import { commonUtil, logEvent, performanceUtil, QavEvent } from '@qnpm/q-design-utils';
import CalendarBottomModule from '../BottomModule';
import Style from '../Calendar/style';
import { updateUserSelectedDate } from '../utils/handle';
import HolidayUtil from '../utils/holidayUtil';
export default class FullScreenCalendar extends PureComponent {
    constructor(props) {
        super(props);
        // 标记 - 用户使用手动选择过
        this.userSelected = false;
        this.computedStyle = undefined;
        /**
         * 关闭页面回传参数
         */
        this.onClose = () => {
            this.props.onClose && this.props.onClose(true);
            this.logShowHide(false);
        };
        /**
         * 选中回调
         * @param data
         */
        this.onSelect = (data) => {
            const { onSelect, mode } = this.props;
            // 更新选中数据
            this.updateSelectedDate(data);
            // 执行回调 - 单选时延迟回调
            if (mode === CALENDAR_TYPE.SINGLE) {
                setTimeout(() => {
                    onSelect && onSelect(data);
                }, 150);
            }
            else {
                onSelect && onSelect(data);
            }
        };
        /**
         * 这里每次选中都会调用，所以不是数组
         * @param data
         */
        this.updateSelectedDate = (data) => {
            const { userSelectedDate } = this.state;
            const { selectedIndex = 0 } = data;
            let nextState = userSelectedDate
                ? [...userSelectedDate]
                : [];
            // selectedIndex为0时，表示选择了第一个日期，此时需要重置用户选择的日期
            if (selectedIndex === 0) {
                nextState = [data];
            }
            else {
                // selectIndex不为0时，表示继续选择
                nextState[selectedIndex] = data;
            }
            this.setState({ userSelectedDate: nextState });
        };
        /**
         * 默认选中日期的回调
         * @param data
         */
        this.onInitCallback = (data) => {
            const nextData = Array.isArray(data) ? data : [data];
            // 使用setTimeout将异步setState变为同步更新，防止底部渲染时首次拿不到数据
            setTimeout(() => {
                this.setState({ userSelectedDate: nextData });
            });
        };
        // dataSource改变，渲染完成回调
        this.onDataSourceRendered = (data) => {
            let nextData = [];
            // 用户如果没有手动选择过，则每次dataSource更新后都更新底部展示数据
            if (!this.userSelected) {
                if (commonUtil.isValidObject(data)) {
                    nextData = [data];
                    // @ts-ignore
                }
                else if (commonUtil.isValidArray(data)) {
                    nextData = data;
                }
            }
            // 只有不为空时才更新
            commonUtil.isValidArray(nextData) &&
                this.setState({ userSelectedDate: nextData });
        };
        this.setStateBarColor();
        // 计算节假日信息，实例化时传入节假日信息；默认使用了mock数据
        FullScreenCalendar.HolidayUtilHandler = new HolidayUtil();
        this.beginTime = props.beginTime || new Date();
        this.state = {
            dataSource: FullScreenCalendar.HolidayUtilHandler.mergeHolidayData(this.props.dataSource)
        };
        // 日历不支持缩放
        this.computedStyle = new Style(false);
        this.logShowHide(true);
        this.listenerHandler = null;
        this.onChange = this.onChange.bind(this);
        this.state = {
            refreshWidth: Dimensions.get('window').width
        };
    }
    componentDidUpdate(prevProps) {
        this.updateDataSource(prevProps);
    }
    componentDidMount() {
        this.toggleSwipeControl(false);
        // 安卓端添加物理键盘
        if (DeviceInfo.isAndroid) {
            this.listenerHandler = BackHandler.addEventListener('hardwareBackPress', () => {
                this.onClose();
                return true;
            });
        }
        // 适配折叠屏
        Dimensions.addEventListener('change', this.onChange);
    }
    componentWillUnmount() {
        this.toggleSwipeControl(true);
        this.listenerHandler && this.listenerHandler.remove();
        Dimensions.removeEventListener('change', this.onChange);
    }
    render() {
        const { mode } = this.props;
        const { headerData, contentData, footerData } = this.getRenderData();
        return (<View style={{ paddingTop: StatusBar.currentHeight, flex: 1 }}>
                <NaviBar {...headerData}/>
                <QSectionCalendar {...contentData} refreshWidth={this.state.refreshWidth}/>
                {mode !== CALENDAR_TYPE.SINGLE ? (<CalendarBottomModule {...footerData} refreshWidth={this.state.refreshWidth}/>) : null}
            </View>);
    }
    /**
     * 屏幕尺寸变化
     * @param dimensions
     */
    onChange(dimensions) {
        const { width } = dimensions.window;
        this.setState({ refreshWidth: width });
    }
    /**
     * 禁止左滑返回
     * @param enable
     */
    toggleSwipeControl(enable) {
        const { swipeBackControl = true } = this.props;
        // eslint-disable-next-line no-undef
        swipeBackControl &&
            global.Ext &&
            global.Ext.setSwipeBackEnabled(enable);
    }
    setStateBarColor() {
        if (DeviceInfo.isIOS) {
            QStatusBar.setStyle('dark', () => { }, (error) => {
                // eslint-disable-next-line no-console
                console.log('JackYang_statueBar_error', JSON.stringify(error));
            });
        }
        else {
            if (parseInt(DeviceInfo.osVersion, 10) >= 23 &&
                QStatusBar &&
                QStatusBar.setStyle) {
                QStatusBar.setStyle('dark', () => { }, () => { });
            }
            else {
                QStatusBar.setColor('#b0b0b0', false, () => { }, () => { });
            }
        }
    }
    getRenderData() {
        const { title, hasDirect, tipsContent, onDirectHandler, selectedPayload, otherInfo, buttons, mode, tipsWrapperCustomStyle, checkedDirect } = this.props;
        const { isTouchMoving, floatDidMount, decelerationRate, userSelectedDate, dataSource } = this.state;
        const headerData = {
            title,
            hasDirect,
            tipsContent,
            onFloatClose: this.onClose,
            onDirectHandler,
            tipsWrapperCustomStyle,
            checkedDirect,
            computedStyle: this.computedStyle
        };
        const contentData = Object.assign(Object.assign({}, this.props), { dataSource, onSelect: this.onSelect, isTouchMoving, finishCallback: false, floatDidMount, onInitCallback: this.onInitCallback, onDataSourceRendered: this.onDataSourceRendered, decelerationRate });
        const footerData = {
            mode,
            selectedPayload,
            otherInfo,
            adaptFooter: false,
            userSelectedDate,
            buttons: commonUtil.isValidArray(buttons)
                ? buttons
                : [{ type: 'default', text: '确定' }]
        };
        return { headerData, contentData, footerData };
    }
    /**
     * 更新完成后比对dataSource，如果更新了则重新Merge节假日
     * @param prevProps
     */
    updateDataSource(prevProps) {
        const { dataSource: prevDataSource } = prevProps;
        const { dataSource, accessibilityPreName } = this.props;
        if (!performanceUtil.fastDeepEqual(prevDataSource, dataSource)) {
            const { userSelectedDate } = this.state;
            const nextDataSource = FullScreenCalendar.HolidayUtilHandler.mergeHolidayData(dataSource);
            const newUserSelectedDate = updateUserSelectedDate(nextDataSource, userSelectedDate);
            this.setState({
                dataSource: nextDataSource,
                userSelectedDate: newUserSelectedDate
            });
            //埋点
            logEvent(new QavEvent({
                page: accessibilityPreName,
                model: 'full_screen_calendar',
                action: 'update_data_source',
                attributes: {
                    operTime: Date.now()
                }
            }));
        }
    }
    logShowHide(visible) {
        logEvent(new QavEvent({
            page: this.props.accessibilityPreName,
            model: 'full_screen_calendar',
            action: visible ? 'show' : 'hide',
            attributes: {
                operTime: Date.now()
            }
        }));
    }
}
